import { Injectable } from '@angular/core';

import { Router } from '@angular/router';
import { SessionHandler } from './session-handler.service';
import { CommonService } from '../../shared/services/common.service';

@Injectable()
export class ErrorHandler {
    
	constructor(private router: Router, public sessionHandler : SessionHandler, public commonService:CommonService) { }

	handle(response) {
		if(response.error!=undefined) {
			console.log("handling error");
			if(response.error.code == 401 || response.error.code == 403){
				console.log("Error : "+response.error.message);
				if(response.error.message=="Access token not valid" || response.error.message=="Session Expired") {
					this.commonService.setLoginRedirectUrl(window.location.hash);
				}
				this.sessionHandler.clearAllItems();
                //this.sessionHandler.saveItem("lastUrl", window.location.hash);
				this.router.navigate(['/login']);
			}else if(response.error.code == 404){
				console.log("Forbidden : "+response);
				window.location.href = "/#/extra/404";
			}else if(response.error.code == 500){
				console.log("Server Exception : "+response);
				window.location.href = "/#/extra/500";
			}
		}
	}

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/shared/services/error-handler.service.ts